import { deepEqual } from 'fast-equals';
import microMemoize from 'micro-memoize';

export type MemoizedPromiseFunction = (...args: any[]) => Promise<any>;

function memoizePromise<F extends MemoizedPromiseFunction>(fn: F): F {
  return microMemoize(fn, { isEqual: deepEqual, isPromise: true, maxSize: 15 });
}

export {
  memoizePromise,
};
